import React from 'react';

import { BlockContainer, Layout, Column } from '../../Layout';
import { Text } from '../../Text';

import { StyledLink, LinkTable, TableColumn } from './styles';

import { TableData } from './MaxInvestDisclosureTableData';

export function MaxInvestDisclosureTable() {
  return (
    <BlockContainer
      id="maxInvestDisclosureTable"
      marginTop={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
      marginBottom={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
      revealOnScroll={false}
    >
      <Layout>
        <Column size={{ 0: 12, tablet: 8 }} flexDirection="column">
          <Text
            as="h1"
            textAlign="center"
            style={{ marginBottom: '1rem', fontWeight: 500 }}
            fontSize={{ 0: 'h1_0', tablet: '5xl' }}
          >
            Greenlight Max + Invest Disclosure Library
          </Text>
          <Text
            textAlign="center"
            style={{ marginBottom: '1rem', fontWeight: 'bold' }}
          >
            (Last Updated January 12, 2021)
          </Text>
          <LinkTable>
            <TableColumn>
              {TableData.column1.map(({ link, linkTitle }, i) => (
                <StyledLink href={link} key={`${i}_${link}`}>
                  {linkTitle}
                </StyledLink>
              ))}
            </TableColumn>
            <TableColumn>
              {TableData.column2.map(({ link, linkTitle }, i) => (
                <StyledLink href={link} key={`${i}_${linkTitle}`}>
                  {linkTitle}
                </StyledLink>
              ))}
            </TableColumn>
          </LinkTable>
        </Column>
      </Layout>
    </BlockContainer>
  );
}
